import logo from 'assets/images/logo/LogoIcon.png';

const LogoIcon = () => {
    return <img src={logo} alt='Builder' width='40' />;
};

export default LogoIcon;
